import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const CustomParamsTypeSelect = observer(({ store, disabled = false }) => {
  return (<>
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={store?.options()}
        //defaultValue={store?.selectedCustomParameters ? store?.selectedCustomParameters : []}
        value={store?.selectedCustomParameters.map((param) => ({label: param.label, uuid: param.uuid}))}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.uuid}
        onChange={(data) => store?.selectParameters(data, "selectedCustomParameters")}
        placeholder="Select"
        isMulti
        isDisabled={disabled}
      />
    </>
  );
});

export default CustomParamsTypeSelect;
